import { ApiError } from '../client';
import type { ConfirmLockSequenceInput } from '../endpoints/confirmLockSequence';
import { getConfirmLockSequenceMockError, moveLockCodePointerInMock } from './lockCodes';

// Mock of the confirm-sequence WRITE: simulate latency, then either reject with an injected backend
// error code (dev/test hook, so the generic banner is exercisable) or move that carril's pointer in
// the shared codes mock, so a follow-up fetchLockCodesMock paints the sequence from its new pointer.
//
// The no-change confirm (`oldPosition === newPosition`) is written like any other: it is the agent
// asserting the server was already right, and the backend emits its event for it too.
export async function confirmLockSequenceMock(
  lockId: string,
  input: ConfirmLockSequenceInput,
): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  const injected = getConfirmLockSequenceMockError();
  if (injected !== null) {
    throw new ApiError(422, injected, { code: injected }, `confirm lock sequence failed: ${injected}`);
  }
  moveLockCodePointerInMock(lockId, input.type, input.newPosition);
}
